import { IServiceResult } from "../../infrastructure/Interfaces/IServiceResult";
import { SVCArancel } from "../../infrastructure/services/api/SVCArancel";
// import IViewPanelesAlumno from "../../presentation/view-interfaces/IViewPanelesAlumno";
import IViewArancelValor from "../../presentation/view-interfaces/IViewArancel";
import IViewMatriculaValor from "../../presentation/view-interfaces/IViewMatricula";
import IViewCAE from "../../presentation/view-interfaces/IViewCAE";
import IViewFormaPagoMulti from "../../presentation/view-interfaces/IViewFormaPagoMulti";
import IViewProcesoItemPago from "../../presentation/view-interfaces/IViewProcesoItemPago";
import IViewResultPago from "../../presentation/view-interfaces/IViewResultPago";
import IViewClienteMandato from "../../presentation/view-interfaces/IViewClienteMandato";
// import IViewComprobanteListado from "../../presentation/view-interfaces/IViewComprobanteListado";
import IViewCombo from "../../presentation/view-interfaces/IViewCombo";
import IViewComercio from "../../presentation/view-interfaces/IViewComercio";
import IViewSaldosPendientes from "../../presentation/view-interfaces/IViewSaldosPendientes";

// export const ObtieneArancel = (selListaArancel: any, codigoCarrera: string, anio: number, periodo: number, anioPromocion: number, idProceso: number) => {
//     let matricula: Array<IViewMatriculaValor> = [];
//     let arancel: Array<IViewArancelValor> = [];
//     SVCArancel.ObtieneArancel(codigoCarrera, anio, periodo, anioPromocion, idProceso).then((res: IServiceResult<any>) => {
//         if (res.result !== undefined) {
//             //let data: any = res.result;
//             /* console.log(data) */
//             /* matricula.push({
//                montoUF: (data.valorMatriculaUF===null?0:data.valorMatriculaUF),
//                montoCLP: (data.valorMatriculaCLP===null?'0':data.valorMatriculaCLP.toString()),
//                codcarr:(data.codcarr===null?'':data.codcarr),
//                cuotaS_MATRICULA:(data.cuotaS_MATRICULA===null?0:data.cuotaS_MATRICULA),
//                monedA_MATRICULA:(data.monedA_MATRICULA===null?0:data.monedA_MATRICULA),
//                fecinivig:(data.fecinivig===null?'':data.fecinivig),
//                fectervig:(data.fectervig===null?'':data.fectervig),
//                montoCLPSumaBeneficioPMatricula:'0',
//                montoSumaBeneficioMatricula:0,
//                CAEclp:0,
//                CAEuf:0,
//                totalCLP:0,
//                totalUF:0,
//                beneficioCAE:data.beneficioCAE,
//                beneficioExterno:data.beneficioExternos,
//                beneficioInterno:data.beneficiosInternos,
//            }); 
//            arancel.push({
//                montoUF: (data.valorArancelUF===null?0:data.valorArancelUF),
//                montoCLP: (data.valorArancelCLP===null?'0':data.valorArancelCLP.toString()),
//                codcarr:(data.codcarr===null?'':data.codcarr),
//                cuotas:(data.cuotas===null?0:data.cuotas),
//                moneda:(data.moneda===null?0:data.moneda),
//                fecinivig:(data.fecinivig===null?'':data.fecinivig),
//                fectervig:(data.fectervig===null?'':data.fectervig),
//                montoSumaBeneficioArancel:0,
//                montoCLPSumaBeneficioArancel:'0',
//                CAEclp:0,
//                CAEuf:0,
//                totalCLP:0,
//                totalUF:0
//            })  */

//             selListaArancel(false, '', matricula, arancel);
//         } else {
//             selListaArancel(true, res.errorDetails, matricula, arancel);
//         }
//     });
// };

export const ObtieneBecas = (selListaArancel: any, rut: number, codigoCarrera: string, anio: number, periodo: number,
    anioPromocion: number, idProceso: number, quiereCAE: boolean, codNegocio: number,
    codigoPlanificacion: number, idPeriodo: number = 0, fechaMatricula: string) => {
    let matricula: Array<IViewMatriculaValor> = [];
    let arancel: Array<IViewArancelValor> = [];
    SVCArancel.ObtieneBecas(rut, codigoCarrera, anio, periodo, anioPromocion, idProceso, quiereCAE, codNegocio,
        codigoPlanificacion, idPeriodo, fechaMatricula).then((res: IServiceResult<any>) => {
            if (res.result !== undefined) {
                let data: any = res.result;
                matricula.push({
                    montoUF: (data.matriculaSaldoOriginal === null ? 0 : data.matriculaSaldoOriginal)/*  (data.montoMatricula===null?0:data.montoMatricula) */,
                    montoCLP: (data.matriculaSaldoCLP === null ? '0' : data.matriculaSaldoCLP.toString()) /* (data.montoCLPMatricula===null?'0':data.montoCLPMatricula.toString()) */,
                    codcarr: '0'/* (data.codcarr===null?'':data.codcarr) */,
                    cuotaS_MATRICULA: 0,/* (data.cuotaS_MATRICULA===null?0:data.cuotaS_MATRICULA), */
                    monedA_MATRICULA: (data.codigoMonedaOriginalMatricula === null ? 0 : data.codigoMonedaOriginalMatricula)/* (data.codigoMonedaMatricula===null?0:data.codigoMonedaMatricula) */,
                    fecinivig: ''/* (data.fecinivig===null?'':data.fecinivig) */,
                    fectervig: ''/* (data.fectervig===null?'':data.fectervig) */,
                    montoCLPSumaBeneficioPMatricula: data.montoCLPSumaBeneficioMatricula.toString()/* data.montoCLPSumaBeneficioPMatricula.toString() */,
                    montoSumaBeneficioMatricula: data.montoSumaBeneficioMatricula /* data.montoSumaBeneficioMatricula */,
                    montoCLPSumaBeneficioPMatriculaInterno: data.montoCLPSumaBeneficioInternoMatricula.toString(),
                    montoSumaBeneficioMatriculaInterno: data.montoSumaBeneficioInternoMatricula,
                    montoCLPSumaBeneficioPMatriculaExterno: data.montoCLPSumaBeneficioExternoMatricula.toString(),
                    montoSumaBeneficioMatriculaExterno: data.montoSumaBeneficioExternoMatricula,
                    CAEclp: 0,
                    CAEuf: 0,
                    totalCLP: parseFloat(data.montoCLPFinalMatricula),
                    totalUF: parseFloat(data.montoFinalMatricula),
                    beneficioCAE: data.beneficioCAE,
                    beneficioExterno: data.beneficioExternos,
                    beneficioInterno: data.beneficiosInternos,
                    esNuevo: data.esNuevo
                });
                arancel.push({
                    montoUF: (data.arancelSaldoOriginal === null ? 0 : data.arancelSaldoOriginal)/*  (data.montoArancel===null?0:data.montoArancel) */,
                    montoCLP: (data.arancelSaldoCLP === null ? '0' : data.arancelSaldoCLP.toString())/* (data.montoCLPArancel===null?'0':data.montoCLPArancel.toString()) */,
                    codcarr: '0'/* (data.codcarr===null?'':data.codcarr) */,
                    cuotas: 0/* (data.cuotas===null?0:data.cuotas) */,
                    moneda: (data.codigoMonedaOriginalArancel === null ? 0 : data.codigoMonedaOriginalArancel)/* (data.moneda===null?0:data.moneda) */,
                    fecinivig: ''/* (data.fecinivig===null?'':data.fecinivig) */,
                    fectervig: ''/* (data.fectervig===null?'':data.fectervig) */,
                    montoCLPSumaBeneficioArancel: data.montoCLPSumaBeneficioArancel === null ? '0' : data.montoCLPSumaBeneficioArancel.toString()/* data.montoCLPSumaBeneficioArancel===null?'0':data.montoCLPSumaBeneficioArancel.toString() */,
                    montoSumaBeneficioArancel: data.montoSumaBeneficioArancel === null ? 0 : data.montoSumaBeneficioArancel/* data.montoSumaBeneficioArancel===null?0:data.montoSumaBeneficioArancel */,
                    montoCLPSumaBeneficioPArancelInterno: data.montoCLPSumaBeneficioInternoArancel.toString(),
                    montoSumaBeneficioArancelInterno: data.montoSumaBeneficioInternoArancel,
                    montoCLPSumaBeneficioPArancelExterno: data.montoCLPSumaBeneficioExternoArancel.toString(),
                    montoSumaBeneficioArancelExterno: data.montoSumaBeneficioExternoArancel,
                    CAEclp: parseFloat(data.montoCLPSumaBeneficioCAEArancel),
                    CAEuf: parseFloat(data.montoSumaBeneficioCAEArancel),
                    totalCLP: parseFloat(data.montoCLPFinalArancel)/* parseInt(data.montoCLPArancel)-parseInt(data.montoCLPSumaBeneficioPMatricula) */,
                    totalUF: parseFloat(data.montoFinalArancel)/* parseInt(data.montoArancel)-parseInt(data.montoSumaBeneficioArancel) */,
                    beneficioCAE: data.beneficioCAE,
                    beneficioExterno: data.beneficioExternos,
                    beneficioInterno: data.beneficiosInternos,
                    tieneCAE: data.tieneCAE,
                    esNuevo: data.esNuevo
                })

                selListaArancel(false, '', matricula, arancel);
            } else {
                selListaArancel(true, res.errorDetails, matricula, arancel);
            }
        });
};
export const ObtieneReglaBecas = (selListaReglaBeca: any, codigoBeneficio: number, codigoSede: string) => {
    let result: any = [];
    SVCArancel.ObtieneReglaBecas(codigoBeneficio, codigoSede).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            /* console.log(data)  */
            selListaReglaBeca(false, '', data);
        } else {
            selListaReglaBeca(true, res.errorDetails, result);
        }
    });
};

export const ObtieneCAE = (selListaArancel: any, rut: number, codigoCarrera: string, anio: number, periodo: number, idProceso: number) => {
    let cae: Array<IViewCAE> = [];
    SVCArancel.ObtieneCAE(rut, codigoCarrera, anio, periodo, idProceso).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;/* 
        console.log(data)  */
            cae.push({
                totalCLP: (data.arancelReferenciaCLP === null ? 0 : data.arancelReferenciaCLP),
                totalUF: (data.arancelReferenciaUF === null ? 0 : data.arancelReferenciaUF)
            })

            selListaArancel(false, '', cae);
        } else {
            selListaArancel(true, res.errorDetails, cae);
        }
    });
};

export const ObtieneFormaPagoMulti = (selListaArancel: any, rut: number, anio: number, periodo: number, codigoNegocio: number, codigoItem: number, codigoSede: number, codigoTipoAlumno: number,
    promocionDesde: number, promocionHasta: number, codigoOrigen: number, codigoCarrera: string, esCae: boolean, idProceso: number, planificacionAcademica: number, idPeriodo: number) => {
    let FP: Array<IViewFormaPagoMulti> = [];
    SVCArancel.ObtieneFormaPagoMulti(rut, anio, periodo, codigoNegocio, codigoItem, codigoSede, codigoTipoAlumno,
        promocionDesde, promocionHasta, codigoOrigen, codigoCarrera, esCae, idProceso, planificacionAcademica, idPeriodo).then((res: IServiceResult<any>) => {
            if (res.result !== undefined) {
                let data: any = res.result;
                data.map((e: any) => {
                    /* FP.push({
                        codigoFormaPago: e.codigoFormaPago,
                        codigoItem: e.codigoItem,
                        detalle: e.nombreFormaPago,
                        cuotas: e.cuotasMaximo,
                        mesInicio: e.mesInicio,
                        anoInicio: e.anioInicio,
                        cantCuotas: e.cantCuotas,
                        diaPago: e.diaPago,
                        montoCLP: e.montoCLP,
                        montoPagado: e.montoPagado,
                        montoOriginal: e.montoUF,
                        pagado: e.pagado,
                        seleccionado: e.seleccionado,
                        mesPago: e.mesPago,
                        fechaPago: e.fechaPago,
                        cuotasMaximo: e.cuotasMaximo,
                        esCF: e.esCF,
                        esFactura: e.esFactura
                    }); */
                });
                selListaArancel(false, '', FP);
            } else {
                selListaArancel(true, res.errorDetails, FP);
            }
        });
};
export const ObtieneBeneficioComplementario = (selListaBeneficio: any, rut: number, anio: number, periodo: number, beneficio: number, codigoCarrera: string) => {
    let result: any = [];
    SVCArancel.ObtieneBeneficioComplementario(rut, anio, periodo, beneficio, codigoCarrera).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            selListaBeneficio(false, '', data);
        } else {
            selListaBeneficio(true, res.errorDetails, result);
        }
    });
};
export const InsertarBeneficioComplementario = (selListaBeneficio: any, rut: number, idBeneficio: number, codPrograma: string, periodo: number, anio: number, sistema: string, idBeneficioC: number, data: any) => {
    let result: any = [];
    SVCArancel.InsertarBeneficioComplementario(rut, idBeneficio, codPrograma, periodo, anio, sistema, idBeneficioC, data).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;/* 
        console.log(data)  */

            selListaBeneficio(false, '', data);
        } else {
            selListaBeneficio(true, res.errorDetails, result);
        }
    });
};
export const QuitarBeneficioComplementario = (selListaBeneficio: any, rut: number, idBeneficio: number, codPrograma: string, periodo: number, anio: number, sistema: string, idBeneficioC: number) => {
    let result: any = [];
    SVCArancel.QuitarBeneficioComplementario(rut, idBeneficio, codPrograma, periodo, anio, sistema, idBeneficioC).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;/* 
        console.log(data)  */

            selListaBeneficio(false, '', data);
        } else {
            selListaBeneficio(true, res.errorDetails, result);
        }
    });
};
export const InsertarClienteMandato = (selListaClienteMandato: any, rut: number, codigoPrograma: string, anio: number, periodo: number, tipo: string, sistema: string) => {
    let result: any = [];
    SVCArancel.InsertarClienteMandato(rut, codigoPrograma, anio, periodo, tipo, sistema).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;/* 
        console.log(data)  */

            selListaClienteMandato(false, '', data);
        } else {
            selListaClienteMandato(true, res.errorDetails, result);
        }
    });
};
export const ObtenerClienteMandato = (selListaClienteMandato: any, rut: number, codigoPrograma: string, anio: number, periodo: number, tipo: string, sistema: string) => {
    let result: any = [];
    SVCArancel.ObtenerClienteMandato(rut, codigoPrograma, anio, periodo, tipo, sistema).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: IViewClienteMandato = res.result;

            selListaClienteMandato(false, '', data);
        } else {
            selListaClienteMandato(true, res.errorDetails, result);
        }
    });
};
export const EliminarClienteMandato = (selListaClienteMandato: any, rut: number, codigoPrograma: string, anio: number, periodo: number, tipo: string, sistema: string) => {
    let result: any = [];
    SVCArancel.EliminarClienteMandato(rut, codigoPrograma, anio, periodo, tipo, sistema).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;/* 
        console.log(data)  */

            selListaClienteMandato(false, '', data);
        } else {
            selListaClienteMandato(true, res.errorDetails, result);
        }
    });
};
export const GuardarFormaPago = (selListaArancel: any, data: any, idProceso: number, codigoNegocio: number) => {
    let result: any = [];
    SVCArancel.GuardarFormaPago(data, idProceso, codigoNegocio).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            selListaArancel(false, '', data);
        } else {
            selListaArancel(true, res.errorDetails, result);
        }
    });
};
export const ObtieneProcesoItemPago = (selListaArancel: any, headers: any, idProceso: number) => {
    let result: Array<IViewProcesoItemPago> = [];
    SVCArancel.ObtieneProcesoItemPago(headers, idProceso).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            /* console.log(data)  */
            data.map((e: any) => {
                result.push({
                    aplicaMonto: e.aplicaMonto,
                    aplicaPorcentaje: e.aplicaPorcentaje,
                    codBen: e.codBen,
                    codigoItem: e.codigoItem,
                    cuotas: e.cuotas,
                    diaPago: e.diaPago,
                    esBeca: e.esBeca,
                    fechaActualizacion: e.fechaActualizacion,
                    formaPago: e.formaPago,
                    idProceso: e.idProceso,
                    idProcesoItemPago: e.idProcesoItemPago,
                    idProcesoNavigation: e.idProcesoNavigation,
                    moneda: e.moneda,
                    monto: e.monto,
                    montoClp: e.montoClp,
                    porcentaje: e.porcentaje,
                    pagado: e.pagado
                });
            });

            selListaArancel(false, '', result);
        } else {
            selListaArancel(true, res.errorDetails, result);
        }
    });
};

export const ObtienePagoTransbank = (selObtenerPagoTransbank: any,
    idProceso: number, codigoNegocio: number, monto: number, codigoComercio: number) => {
    let list: any = [];
    SVCArancel.ObtienePagoTransbank(idProceso, codigoNegocio, monto, codigoComercio).then((res: any) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            //console.log(data)
            selObtenerPagoTransbank(false, '', data,);
        } else {
            selObtenerPagoTransbank(true, res.errorDetails, list,);
        }
    });
}
export const ObtieneResultPagoTransbank = (selObtenerPagoTransbank: any,
    token: string, ordenCompra: string, codigoItem: number, codigoComercio: number) => {
    let list: Array<IViewResultPago> = [];
    SVCArancel.ObtieneResultPagoTransbank(token, ordenCompra, codigoItem, codigoComercio).then((res: any) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            /* console.log(data) */
            list.push({
                idOCWebplay: data.idOCWebplay,
                amount: data.amount,
                status: data.status,
                buyOrden: data.buyOrden,
                transactionDate: data.transactionDate,
                authorizationCode: data.authorizationCode,
                responseCode: data.responseCode,
                ResponseDescription: data.responseDescription
            });
            selObtenerPagoTransbank(false, '', list,);
        } else {
            selObtenerPagoTransbank(true, res.errorDetails, list,);
        }
    });
}
export const InsertarExcepcion = (selListaExcepcion: any, rut: number, codigoPrograma: string, anio: number, periodo: number, codigoTipoExcepcion: number, codigoExcepcion: number, codigoNegocio: number) => {
    let result: any = [];
    SVCArancel.InsertarExcepcion(rut, codigoPrograma, anio, periodo, codigoTipoExcepcion, codigoExcepcion, codigoNegocio).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;

            selListaExcepcion(false, '', data);
        } else {
            selListaExcepcion(true, res.errorDetails, result);
        }
    });
};
export const InsertarComprobante = (selListaComprobante: any, rut: number, codigoPrograma: string, anio: number, periodo: number, base64: string, sistema: string, extension: string, codNegocio: number, codigoPlanificacion: number, idPeriodo: number, idPersona: number) => {
    let result: any = [];
    SVCArancel.InsertarComprobante(rut, codigoPrograma, anio, periodo, base64, sistema, extension, codNegocio, codigoPlanificacion, idPeriodo, idPersona).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;

            selListaComprobante(false, '', data);
        } else {
            selListaComprobante(true, res.errorDetails, result);
        }
    });
};
export const ObtieneTransferenciaItemPago = (selObtenerPagoTransbank: any,
    headers: any, idItemPago: number, idTransferencia: number) => {
    let list: Array<IViewResultPago> = [];
    SVCArancel.ObtieneTransferenciaItemPago(headers, idItemPago, idTransferencia).then((res: any) => {
        if (res.result !== undefined) {
            let data: Array<IViewResultPago> = res.result;
            /* console.log(data) */
            selObtenerPagoTransbank(false, '', data);
        } else {
            selObtenerPagoTransbank(true, res.errorDetails, list,);
        }
    });
}
export const ObtenerDocumento = (selObtenerDocumentos: any,
    guid: string) => {
    let list: any;
    SVCArancel.ObtenerDocumento(guid).then((res: any) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            /* console.log(data) */
            selObtenerDocumentos(false, '', data);
        } else {
            selObtenerDocumentos(true, res.errorDetails, list,);
        }
    });
}

export const ObtenerOC = (selObtenerOCs: any,
    rut: number, idProceso: number) => {
    let list: any;
    SVCArancel.ObtenerOC(rut, idProceso).then((res: any) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            /* console.log(data) */
            selObtenerOCs(false, '', data);
        } else {
            selObtenerOCs(true, res.errorDetails, list,);
        }
    });
}

export const ObtieneCtaCtecomplementario = (selListaCtaCte: any, idClienteComplemenatrio: number) => {
    let list: any;
    SVCArancel.ObtieneCtaCtecomplementario(idClienteComplemenatrio).then((res: any) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            /* console.log(data) */
            selListaCtaCte(false, '', data);
        } else {
            selListaCtaCte(true, res.errorDetails, list,);
        }
    });
}
export const UpdateCtaCtecomplementario = (selListaCtaCte: any, idClienteComplemenatrio: number) => {
    let list: any;
    SVCArancel.UpdateCtaCtecomplementario(idClienteComplemenatrio).then((res: any) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            /* console.log(data) */
            selListaCtaCte(false, '', data);
        } else {
            selListaCtaCte(true, res.errorDetails, list,);
        }
    });
}

export const ObtieneMesesPago = (selListaMesesPago: any, rut: number, dia: number, negocio: number, carrera: string, mes: string, codigoPlanificacion: number, idPeriodo: number, idPersona: number) => {
    let list: Array<IViewCombo> = [];
    SVCArancel.ObtieneMesesPago(rut, dia, negocio, carrera, mes, codigoPlanificacion, idPeriodo, idPersona).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            data.map((e: any) => {
                list.push({ ID: e.mes, descripcion: e.nombreMes });
            });

            selListaMesesPago(false, '', list);
        } else {
            selListaMesesPago(true, res.errorDetails, list);
        }
    });
}
export const ObtieneCuotasPago = (selListaCuotasPago: any, rut: number, dia: number, negocio: number, codigoItem: number, carrera: string, mes: string, codigoPlanificacion: number, idPeriodo: number, idPersona: number) => {
    let list: number = 0;
    SVCArancel.ObtieneCuotasPago(rut, dia, negocio, codigoItem, carrera, mes, codigoPlanificacion, idPeriodo, idPersona).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: number = res.result;

            selListaCuotasPago(false, '', data);
        } else {
            selListaCuotasPago(true, res.errorDetails, list);
        }
    });
}

export const ObtieneCodComercio = (selListaComercio: any, negocio: number, carrera: string, codItem: number) => {
    let list: Array<IViewComercio> = [];
    SVCArancel.ObtieneCodComercio(negocio, carrera, codItem).then((res: IServiceResult<any>) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            data.map((e: any) => {
                list.push({ codComercio: e.codigoComercio, nombre: e.nombreCodigoComercio, descripcion: e.descripcionCodigoComercio });
            });
            selListaComercio(false, '', list);
        } else {
            selListaComercio(true, res.errorDetails, list);
        }
    });
}

export const ObtenerFecha1erPago = (selObtenerFecha: any,
    idProceso: number) => {
    let list: any;
    SVCArancel.ObtenerFecha1erPago(idProceso).then((res: any) => {
        if (res.result !== undefined) {
            let data: any = res.result;
            /* console.log(data) */
            selObtenerFecha(false, '', data);
        } else {
            selObtenerFecha(true, res.errorDetails, list,);
        }
    });
}

export const ObtieneSaldosPendientesPorPagar = (selListaSaldosPendientesPorPagar: any, headers: any, rut: number, codigoCarrera: string, codSede: number, idProceso: number,
    quiereCAE: boolean, codNegocio: number, codigoPlanificacion: number, idPeriodo: number) => {
    let saldosPendientes: Array<IViewSaldosPendientes> = [];
    SVCArancel.ObtieneSaldosPendientesPorPagar(headers, rut, codigoCarrera, codSede, idProceso, quiereCAE, codNegocio,
        codigoPlanificacion, idPeriodo).then((res: IServiceResult<any>) => {
            if (res.result !== undefined) {
                let data: any = res.result;
                saldosPendientes = data;

                selListaSaldosPendientesPorPagar(false, '', saldosPendientes);
            } else {
                selListaSaldosPendientesPorPagar(true, res.errorDetails, saldosPendientes);
            }
        });
};